<template>
    <n-form ref="baseExFormRef" :model="baseExValue" :rules="rules" size="medium" :style="{minWidth: '311px'}" >
        <n-form-item :label="$t('event4_text1')" path="name">
            <n-input v-model:value="baseExValue.name" placeholder="" />
        </n-form-item>
        <n-form-item :label="$t('event4_text17')" path="mail">
            <n-input v-model:value="baseExValue.mail" placeholder="" />
        </n-form-item>
        <n-form-item :label="$t('event4_text3')" path="areaStr">
            <n-input v-model:value="baseExValue.areaStr" placeholder="" clearable readonly  @click="openAreaOption()">
                <template #suffix>
                    <n-icon :component="ChevronDown" />
                </template>
            </n-input>
            <n-drawer v-model:show="areaOptionFlag" placement="bottom" :mask-closable="maskFlag" default-height="375">
                <n-drawer-content>
                    <div style="font-size: 14px;margin-bottom: 5px;" v-for="(o,index) in areaOption" :key="index" @click="o.fun(o.value, o.label)">{{o.label}}</div>
                </n-drawer-content>
            </n-drawer>
        </n-form-item>
        <n-form-item :label="$t('event4_text4')" path="unitName">
            <n-input v-model:value="baseExValue.schoolCode" v-show="noShow"></n-input>
            <n-input v-model:value="baseExValue.unitName" placeholder="" clearable readonly @click="openSchoolOption">
                <template #suffix>
                    <n-icon :component="ChevronDown" />
                </template>
            </n-input>
            <n-drawer v-model:show="schoolOptionFlag" placement="bottom" default-height="375">
                <n-drawer-content header-class="schoolOption">
                    <template #header>
                        <n-input-group>
                            <n-input-group-label><n-icon :component="Search" /></n-input-group-label>
                            <n-input v-model:value="schooltFilterText" clearable :placeholder="$t('event4_text15')"/>
                        </n-input-group>
                    </template>
                    <n-spin size="large" stroke="#66bb6a" :show="extensionSpin" style="height: 200px">
                        <template v-if="filterSchoolOption.length > 0">
                            <div style="font-size: 14px;margin-bottom: 5px;" v-for="(o,index) in filterSchoolOption" :key="index" @click="setSchool(o.name, o.type, o.code)">{{o.name}}</div>
                        </template>
                        <template v-else>
                            <div v-if="!extensionSpin" style="text-align: center;margin-top: 50px;color: #9E9E9E;font-size: 14px;">
                                {{ $t('event4_text6') }}
                            </div>
                        </template>
                    </n-spin>
                </n-drawer-content>
            </n-drawer>
        </n-form-item>
        <n-form-item :label="$t('event4_text5')" path="unitType">
            <n-select v-model:value="baseExValue.unitType" placeholder="" :options="unitTypes"/>
        </n-form-item>
        <n-form-item :label="$t('event4_text2')" path="jobTitle">
            <n-input v-model:value="baseExValue.jobTitle" placeholder="" />
        </n-form-item>
    </n-form>
</template>
<script>
    import country from '@/assets/js/country_v2.json'
    import { ref, reactive, defineComponent, computed } from 'vue'
    import { useStore } from "vuex"
    import { useI18n } from "vue-i18n"
    import { ChevronDown, Search } from '@vicons/ionicons5'
    
    export default defineComponent({
        setup() {
            // 元件宣告
            const i18n = useI18n()
            const { t } = i18n
            const store = useStore()
            var wholeLang = ''
            switch(i18n.locale.value) {
                case 'tw':
                    wholeLang = 'zh-tw'
                break
                case 'cn':
                    wholeLang = 'zh-cn'
                break
                case 'jp':
                    wholeLang = 'ja-jp'
                break
                case 'kr':
                    wholeLang = 'ko-kr'
                break
                default:
                    wholeLang = 'en-us'
            }
            const noShow = false
            const baseExFormRef = ref(null)
            const extensionSpin = ref(false)
            const areaOptionFlag = ref(false)
            const schoolOptionFlag = ref(false)
            const maskFlag = ref(true)
            const areaOption = ref([])
            const schoolOption = ref([])
            const schooltFilterText = ref('')
            const baseEx = store.getters['coreApi/baseEx']

            const rules = {
                name: {
                    required: true,
                    trigger: ["blur"],
                    validator(rule, value) {
                        const regex1 = /[~!@#$%^&*()_+|}{?><\/.,\-=`;\[\]']/;
                        const regex2 = /(\ud83c[\udf00-\udfff])|(\ud83d[\udc00-\ude4f\ude80-\udeff])|[\u2600-\u2B55]/;

                        if (!value) {
                            return new Error(t('error_14'));
                        } else if (regex1.test(value)) {
                            return new Error("格式錯誤(請不要包含特殊符號)");
                        } else if (regex2.test(value)) {
                            return new Error("格式錯誤(請不要包含特殊符號)");
                        }
                        return true;
                    },                    
                },
                jobTitle: {
                    required: true,
                    message: t('error_14'),
                    trigger: ["blur"]
                },
                unitType: {
                    required: true,
                    message: t('error_14'),
                    trigger: ["blur"]
                }, 
                areaStr: {
                    key: 'areaStr',
                    required: true,
                    message: t('error_14'),
                    trigger: ["blur"]
                },
                unitName: {
                    required: true,
                    message: t('error_14'),
                    trigger: ["blur"]
                },
                mail:{
                    required: true,
                    trigger: ["blur"],
                    validator(rule, value) {
                        const regexEmail = /^\w+((-\w+)|(\.\w+))*@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/

                        if (!value) {
                            return new Error(t('error_14'));
                        } else if (!regexEmail.test(value)) {
                            return new Error(t('error_15'));
                        }

                        return true;
                    },  
                }
            }

            const unitTypes = [
                {
                    label: t('event4_text7'),
                    value: '1'
                },
                {
                    label: t('event4_text8'),
                    value: '2'
                },
                {
                    label: t('event4_text9'),
                    value: '3'
                },
                {
                    label: t('event4_text10'),
                    value: '4'
                },
                {
                    label: t('event4_text11'),
                    value: '5'
                },
                {
                    label: t('event4_text12'),
                    value: '6'
                },
                {
                    label: t('event4_text13'),
                    value: '7'
                },
            ]

            const baseExValue = reactive({
                name: "",
                jobTitle: "",
                country: null,
                province: null,
                city: null,
                unitName: "",
                unitType: "",
                areaStr: "",
                schoolCode: "",
                mail:""
            })

            if(baseEx != null) {                
                let keys = Object.keys(baseExValue)
                keys.forEach(k=>{
                    if(baseEx[k] != null && baseEx[k] != '') {
                        switch(k) {
                            case 'country':{
                                if(baseEx[k]) {
                                    let temp = country.filter(c=>(c.c == baseEx[k] && c.l == wholeLang && c.t == 'c'))
                                    if(temp.length > 0) {
                                        baseExValue[k] = baseEx[k]
                                        baseExValue.areaStr = temp[0]?.cN
                                    }
                                }
                                break
                            }
                            case 'province':{
                                if(baseEx[k]){
                                    let areaType = baseExValue.country == 'TW' ? 'y' : 'p'
                                    let serchKey = baseExValue.country == 'TW' ? 'y' : 'p'
                                    let temp = country.filter(c=>(
                                        c.c == baseExValue.country
                                        && c[serchKey] == baseEx[k]
                                        && c.l == wholeLang
                                        && c.t == areaType)
                                    )
                                    if(temp.length > 0) {
                                        baseExValue[k] = baseEx[k]
                                        baseExValue.areaStr += `/${temp[0][serchKey+'N']}`
                                    }
                                }
                                break
                            }
                            case 'city':{
                                if(baseEx[k]){
                                    let areaType = baseExValue.country == 'TW' ? 'd' : 'y'
                                    let serchKey = baseExValue.country == 'TW' ? 'd' : 'y'
                                    let temp = country.filter(c=>(
                                        c.c == baseExValue.country
                                        && c[serchKey] == baseEx[k]
                                        && c.l == wholeLang
                                        && c.t == areaType)
                                    )
                                    if(temp.length > 0) {
                                        baseExValue[k] = baseEx[k]
                                        baseExValue.areaStr += `/${temp[0][serchKey+'N']}`
                                    }
                                }
                                break
                            }
                            default: 
                            baseExValue[k] = baseEx[k]
                        }
                    }
                })
            }

            const openAreaOption = ()=>{
                areaOptionFlag.value = true
                switch (i18n.locale.value) {
                case 'jp':
                    getLayerTwoList('JP', '日本')
                    break
                case 'kr':
                    getLayerTwoList('KR', '대한민국')
                    break
                default:
                    areaOption.value = getLayerOneList()
                    break
                }
            }

            const getLayerOneList = () => {
                let res = []
                country.forEach(function(c){
                    if(c.l == wholeLang && c.t == 'c'){
                        res.push({
                            value: c.c,
                            label: c.cN,
                            fun: getLayerTwoList
                        })
                    }
                })

                if(wholeLang == 'zh-tw'){
                    res.sort(function(a, b){
                        switch(a.label){
                            case '臺灣':
                                return -1
                            default:
                                return a.label.length - b.label.length;
                        }
                    })
                }
                return res
            }

            const getLayerTwoList = (id, name) =>{
                baseExValue.country = id
                baseExValue.areaStr = name

                // 清空
                baseExValue.province = null
                baseExValue.city = null
                baseExValue.schoolCode = null
                baseExValue.unitName = null

                maskFlag.value = false
                let res = []
                if(baseExValue.country == 'TW'){
                    country.forEach(function(c){
                        if(c.l == wholeLang && c.t == 'y' && c.c == id){
                            res.push({
                                value: c.y,
                                label: c.yN,
                                fun: getLayerThrList
                            })
                        }
                    })
                } else {
                    country.forEach(function(c){
                        if(c.l == wholeLang && c.t == 'p' && c.c == id){
                            res.push({
                                value: c.p,
                                label: c.pN,
                                fun: getLayerThrList
                            })
                        }
                    })
                }
                if(res.length > 0){
                    areaOption.value = res
                } else {
                    areaOptionFlag.value = false                        
                }
            }

            const getLayerThrList = (id, name)=>{
                baseExValue.province = id
                baseExValue.areaStr += `/${name}`
                let res = []

                if(baseExValue.country == 'TW'){
                    country.forEach(function(c){
                        if(c.l == wholeLang && c.t == 'd' && c.c == baseExValue.country && c.y == id){
                            res.push({
                                value: c.d,
                                label: c.dN,
                                fun: setThrId
                            })
                        }
                    })
                } else {
                    // 北京 天津 上海 重慶 不用往下選
                    let exception = ['11', '12', '31', '50']
                    if(baseExValue.country == 'CN' && exception.indexOf(id) >= 0){
                        // 不處理
                    } else {
                        country.forEach(function(c){
                            if(c.l == wholeLang && c.t == 'y' && c.c == baseExValue.country && c.p == id){
                                res.push({
                                    value: c.y,
                                    label: c.yN,
                                    fun: setThrId
                                })
                            }
                        })
                    }
                }

                if(res.length > 0){
                    areaOption.value = res
                } else {
                    // 解開遮罩所調
                    maskFlag.value = true
                    // 關閉抽屜
                    areaOptionFlag.value = false
                }
            }

            const setThrId = (thrId, thrName)=>{
                baseExValue.city = thrId
                baseExValue.areaStr += `/${thrName}`

                // 解開遮罩所調
                maskFlag.value = true
                // 關閉抽屜
                areaOptionFlag.value = false
            }

            const setSchool = (name, type, code) =>{
                baseExValue.unitName = name
                baseExValue.schoolCode = code
                if(type){
                    baseExValue.unitType = type
                }
                schoolOptionFlag.value = false
            }

            const openSchoolOption = () =>{
                baseExFormRef.value?.validate(
                    async(errors) => {
                        if (!errors) {
                            schoolOptionFlag.value = true
                            extensionSpin.value = true
                            schooltFilterText.value = ''
                            let data = {
                                country: baseExValue.country,
                                province: baseExValue.province,
                                city: baseExValue.city,
                            }
                            await store.dispatch('coreApi/getSchoolData', data).then( res => {
                                schoolOption.value = res
                            }).catch( (e) =>{
                                console.log(e)
                            }).finally(()=>{
                                extensionSpin.value = false
                            })
                        }
                    },
                    (rule) => {
                        return rule?.key === "areaStr";
                    }
                )
            }

            const filterSchoolOption = computed( ()=> {
                if(schooltFilterText.value != ''){
                    let schoolRes = schoolOption.value.filter(e=> e.name.toLowerCase().indexOf(schooltFilterText.value.toLowerCase()) >= 0)
                    // if(wholeLang == 'zh-cn' && schoolRes.length == 0){
                    // 2025/2/4 依據上面指示，開啟所有的語系都可以直接輸入未存在的學校
                    if(schoolRes.length == 0){
                        schoolRes.push({code: null, name: schooltFilterText.value, type: null})
                    }
                    return schoolRes
                } else {
                    return schoolOption.value
                }
            })

            return {
                openAreaOption,
                setSchool,
                ChevronDown,
                Search,
                unitTypes,
                rules,
                schoolOptionFlag,
                areaOption,
                maskFlag,
                schooltFilterText,
                schoolOption,
                baseExFormRef,
                baseExValue,
                openSchoolOption,
                extensionSpin,
                noShow,
                areaOptionFlag,
                filterSchoolOption,
            }
        }
    })
</script>
<style lang="less">
    .schoolOption{
        .n-drawer-header__main{
            width: 100%;
        }
    }
</style>